module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8003.72b6855d.png";